export default {
  LATE: "LATE",
  OVERDUE: "OVERDUE",
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
  DONE_DUE_DATE: "DONE_DUE_DATE",
  DONE_END_DATE: "DONE_END_DATE",
  labels: {
    LATE: "Atrasadas",
    IN_PROGRESS: "A concluir",
    DONE: "Concluídas",
    DONE_DUE_DATE: "Concluídas",
    DONE_END_DATE: "Concluídas",
  },
} as const;
